export default __webpack_public_path__ + "static/media/8 (1).4dd724b2.jpg";